window.__ = window._;